export enum Environment {
  Preview = 'preview',
  Production = 'production',
  Qa = 'qa', // used only for the GlobalComponents stack (not the DX stack)
}
